module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/babel-runtime/core-js/object/create.js
// module id = 230
// module chunks = 1